import { render } from "./GoalForm.vue?vue&type=template&id=5b155fff&scoped=true"
import script from "./GoalForm.vue?vue&type=script&lang=js"
export * from "./GoalForm.vue?vue&type=script&lang=js"

import "./GoalForm.vue?vue&type=style&index=0&id=5b155fff&lang=scss&scoped=true"
import "./GoalForm.vue?vue&type=style&index=1&id=5b155fff&lang=scss"
script.render = render
script.__scopeId = "data-v-5b155fff"

export default script